import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'print_jobs',
    pluginName: '',
    entityName: 'PRINT_QUEUE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''

});

// Fetch statistic action creators
export const fetchPrintQueueInit = () => {
    return crudActions.fetchInit();
};
export const fetchPrintQueueStart = () => {
    return crudActions.fetchStart();
};
export const fetchPrintQueueSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchPrintQueueFail = () => {
    return crudActions.fetchFail();
};


export const fetchPrintQueueCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchPrintQueueInit());
        try {
            let countRes = await rest.post("/print_jobs/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchPrintQueueSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchPrintQueueFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch print queue."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchPrintQueueFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch print queue."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchPrintQueue = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchPrintQueueInit());
        try {
            let listRes = await rest.post("/print_jobs/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchPrintQueueSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchPrintQueueFail());
            return []

        } catch (error) {
            dispatch(fetchPrintQueueFail());
            return []

        }
    }
}

// custom actions
export const rePrint = (PrintQueueID, id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/print_jobs/re_trigger', { PrintQueueID: PrintQueueID, ...id });
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Re print success"}`,
                    options: {
                        variant: 'success'
                    }
                });

                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}
// Custom functions 
export const downloadPrintQueueStart = () => {
    return {
        type: 'PRINT_QUEUE|PRINT_QUEUE_DOWNLOAD_FAIL',
    };
};
export const downloadPrintQueueSuccess = () => {
    return {
        type: 'PRINT_QUEUE|PRINT_QUEUE_DOWNLOAD_FAIL'
    };
};
export const downloadPrintQueueFail = () => {
    return {
        type: 'PRINT_QUEUE|PRINT_QUEUE_DOWNLOAD_FAIL'
    };
};
